export const config = {
  apiUrlCompany: "https://prod-bf0854569a80.curiotechnologies.com:7010/",
  apiUrlTravel: "https://prod-bf0854569a80.curiotechnologies.com:7020/",
  apiUrlSuperAdmin: "https://prod-bf0854569a80.curiotechnologies.com:5000/",
  apiExpense: "https://prod-bf0854569a80.curiotechnologies.com:7030/",
  apiMidOffice : "https://prod-bf0854569a80.curiotechnologies.com:7060/"
};
